import { Badge } from 'components/ui';

/** Derives an "in stock / low / out of stock" pill from quantity + threshold. */
export function StockBadge({ stockQuantity, lowStockThreshold }) {
  if (stockQuantity == null) return <Badge tone="neutral">Stock N/A</Badge>;
  if (stockQuantity <= 0) return <Badge tone="danger">Out of stock</Badge>;
  if (lowStockThreshold != null && stockQuantity <= lowStockThreshold) {
    return <Badge tone="warning">Low · {stockQuantity}</Badge>;
  }
  return <Badge tone="success">In stock · {stockQuantity}</Badge>;
}

export default StockBadge;
